import { render, staticRenderFns } from "./ClinicPage.vue?vue&type=template&id=2f83576e"
import script from "./ClinicPage.vue?vue&type=script&lang=js"
export * from "./ClinicPage.vue?vue&type=script&lang=js"
import style0 from "./ClinicPage.vue?vue&type=style&index=0&id=2f83576e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports